import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Helper functions
export const supabaseHelpers = {
  // Get current authenticated user
  getCurrentUser: async () => {
    const { data: { user } } = await supabase.auth.getUser();
    return user;
  },

  // Get user profile
  getProfile: async (userId) => {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();
    
    if (error) throw error;
    return data;
  },

  // Update user profile
  updateProfile: async (userId, updates) => {
    const { data, error } = await supabase
      .from('profiles')
      .update(updates)
      .eq('id', userId)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  // Get user's packages
  getUserPackages: async (userId) => {
    const { data, error } = await supabase
      .from('user_packages')
      .select(`
        *,
        packages (*)
      `)
      .eq('user_id', userId)
      .eq('status', 'active');
    
    if (error) throw error;
    return data;
  },

  // Get workout with exercises
  getWorkoutWithExercises: async (workoutId) => {
    const { data: workout, error: workoutError } = await supabase
      .from('workouts')
      .select('*')
      .eq('id', workoutId)
      .single();
    
    if (workoutError) throw workoutError;

    const { data: exercises, error: exercisesError } = await supabase
      .from('exercises')
      .select('*')
      .eq('workout_id', workoutId)
      .order('set_number')
      .order('order_index');
    
    if (exercisesError) throw exercisesError;

    return { workout, exercises };
  },

  // Check if user is admin
  isAdmin: async (userId) => {
    const { data, error } = await supabase
      .from('profiles')
      .select('admin, is_admin, role')
      .eq('id', userId)
      .single();
    
    if (error) return false;
    return data?.admin === true || data?.is_admin === true || data?.role === 'admin';
  },

  // Increment workout stats
  incrementWorkoutStats: async (userId, isSwim, distance = 0) => {
    try {
      if (isSwim && distance > 0) {
        await supabase.rpc('increment_swim_distance', {
          user_id_input: userId,
          distance_input: distance
        });
      }
      
      await supabase.rpc('increment_workouts_completed', {
        user_id_input: userId
      });
    } catch (error) {
      console.error('Error incrementing stats:', error);
    }
  }
};

export default supabase;
